module.exports = __webpack_public_path__ + "img/logo.194bb616.png";